import { Box, Radio } from '@ksyos/design-system';
import type { ICheckBoxGroupWithTextFieldProps } from './CheckBoxGroup';
import { RadioGroupFormGroup } from '../pages/episodeCategory/customControls/processActivityFormGroupFields';
import { CheckboxesWithTextField } from './CheckBoxGroup';

interface IRadioGroupWithAdditionalCheckboxesProps {
    checkboxOptions: ICheckBoxGroupWithTextFieldProps['checkboxOptions'];
    error?: string;
    fieldKey: string;
    hasErrors?: boolean;
    isRequired: boolean;
    label: string;
    noLabel: string;
    noValue: string;
    onChange: <T extends keyof {}>(key: T, value: {}[T]) => void;
    value: string | null;
    yesLabel: string;
    yesValue: string;
}

export function RadioGroupWithAdditionalCheckboxes(props: IRadioGroupWithAdditionalCheckboxesProps) {
    const {
        error,
        hasErrors,
        fieldKey,
        isRequired,
        label,
        yesValue,
        noValue,
        yesLabel,
        noLabel,
        checkboxOptions,
        value,
    } = props;

    return (
        <RadioGroupFormGroup
            fieldKey={fieldKey}
            isRequired={isRequired}
            label={label}
        >
            <Radio
                key={yesValue}
                label={yesLabel}
                value={yesValue}
            />

            <>
                {value === yesValue && (
                    <Box
                        mb={2}
                        ml={8}
                        mt={1}
                    >
                        <CheckboxesWithTextField
                            checkboxOptions={checkboxOptions}
                            error={error}
                            hasErrors={hasErrors}
                        />
                    </Box>
                )}
            </>
            <Radio
                key={noValue}
                label={noLabel}
                value={noValue}
            />
        </RadioGroupFormGroup>
    );
}
